//General
import React, { useState, useContext, useEffect } from "react";
//Styles
import { Modal } from "react-bootstrap";
import {
  FormControlLabel,
  Checkbox,
  Autocomplete,
  TextField,
  FormHelperText,
} from "@mui/material";
import { Formik, Form } from "formik";
//Context
import { ServiceContext } from "../../data/services/ServiceContext";
import { CustomerContext } from "../../data/customer/CustomerContext";
//Redux
import { useSelector, useDispatch } from "react-redux";
//Actions
import { getCities, getDistricts } from "../../data/general/LocationSlice";
//Components
import CapitalizedFormikField from "../../components/CapitalizedFormikField";
//Validation
import { useValidations } from "../../data/ValidationContext";
import * as Yup from "yup";

// servis ekleme modalı

function ServiceAddModal({ show, handleClose }) {
  const { addService } = useContext(ServiceContext);
  const { customers, addCustomer } = useContext(CustomerContext);
  //Validation

  const { vs_customer, vs_service } = useValidations();


  const [customerType, setCustomerType] = useState("bireysel");
  const dispatch = useDispatch();
  const { cities, districts } = useSelector((state) => state.location);

  const [searchedCity, setSearchedCity] = useState("");
  //Formik İnitial

  const initialValues = {
    fullName: "",
    phone1: "",
    phone2: "",
    phone3: "",
    customerType: "bireysel",
    tcNo: "",
    vergiNo: "",
    vergiDairesi: "",
    city: "",
    district: "",
    address: "",
    brand: "",
    device: "",
    deviceModel: "",
    issue: "",
    note: "",
    warranty: "var",
    availableDate: "",
    availableStart: "",
    availableEnd: "",
    urgency: false,
  };
  // şehirler ve ilçeler için useeffect
  useEffect(() => {
    if (show && cities.length === 0) {
      dispatch(getCities({ signal: null }));
    }
  }, [show, cities.length, dispatch]);

  useEffect(() => {
    if (searchedCity) {
      dispatch(getDistricts({ city: searchedCity }));
    }
  }, [searchedCity, dispatch]);

  // HTML 

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Formik
        initialValues={initialValues}
        validationSchema={Yup.object().concat(vs_customer).concat(vs_service)}
        onSubmit={(values) => {
          const customerId = customers.length + 1;

          addCustomer({
            id: customerId,
            fullName: values.fullName,
            phone1: values.phone1,
            phone2: values.phone2,
            phone3: values.phone3,
            customerType: values.customerType,
            tcNo: values.tcNo,
            vergiNo: values.vergiNo,
            vergiDairesi: values.vergiDairesi,
            city: values.city,
            district: values.district,
            address: values.address,
          });

          addService({
            customerId,
            brand: values.brand,
            device: values.device,
            deviceModel: values.deviceModel,
            issue: values.issue,
            note: values.note,
            warranty: values.warranty,
            availableDate: values.availableDate,
            availableStart: values.availableStart,
            availableEnd: values.availableEnd,
            urgency: values.urgency,
            phone3: values.phone3,
          });

          handleClose();
        }}
      >
        {({ values, handleChange, setFieldValue, errors, touched, handleBlur }) => (
          <Form>
            <Modal.Header closeButton>
              <Modal.Title className="d-flex justify-content-between align-items-center w-100">
                <span>Servis Oluştur</span>
                <div className="d-flex align-items-center gap-2">
                  <CapitalizedFormikField
                    name="phone3"
                    label="Kaynak"
                    variant="outlined"
                    size="small"
                    style={{ width: 140, height: 36 }}
                    onBlur={handleBlur}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values.urgency}
                        onChange={handleChange}
                        name="urgency"
                        color="error"
                      />
                    }
                    label="Acil"
                    style={{ margin: 0 }}
                  />
                </div>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="d-flex flex-column flex-lg-row gap-4">
                {/* Sol sütun */}
                <div
                  className="flex-fill p-3"
                  style={{
                    border: "1px solid rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                   
                  }}
                >
                  <h5>Müşteri Bilgileri</h5>
                  <CapitalizedFormikField
                    name="fullName"
                    label="Müşteri Adı Soyadı"
                    variant="outlined"
                    size="small"
                    fullWidth
                    className="my-2"
                    onBlur={handleBlur}
                    error={touched.fullName && Boolean(errors.fullName)}
                    helperText={touched.fullName && errors.fullName}
                  />
                  <CapitalizedFormikField
                    name="phone1"
                    label="Telefon 1"
                    variant="outlined"
                    size="small"
                    fullWidth
                    className="my-2"
                    onBlur={handleBlur}
                    error={touched.phone1 && Boolean(errors.phone1)}
                    helperText={touched.phone1 && errors.phone1}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, ""); // rakam dışı karakterleri sil
                    }}
                  />
                  <CapitalizedFormikField
                    name="phone2"
                    label="Telefon 2"
                    variant="outlined"
                    size="small"
                    fullWidth
                    className="my-2"
                    onBlur={handleBlur}
                    error={touched.phone2 && Boolean(errors.phone2)}
                    helperText={touched.phone2 && errors.phone2}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, ""); // rakam dışı karakterleri sil
                    }}
                  />

                  <div className="my-2">
                    <label className="form-label">Müşteri Türü</label>
                    <select
                      name="customerType"
                      className="form-select"
                      value={customerType}
                      onChange={(e) => {
                        setCustomerType(e.target.value);
                        setFieldValue("customerType", e.target.value);
                      }}
                      onBlur={handleBlur}
                    >
                      <option value="bireysel">Bireysel</option>
                      <option value="kurumsal">Kurumsal</option>
                    </select>
                  </div>

                  {values.customerType === "bireysel" ? (
                    <CapitalizedFormikField
                      name="tcNo"
                      label="T.C. Kimlik No"
                      variant="outlined"
                      size="small"
                      fullWidth
                      className="my-2"
                      onBlur={handleBlur}
                      error={touched.tcNo && Boolean(errors.tcNo)}
                      helperText={touched.tcNo && errors.tcNo}
                    />
                  ) : (
                    <div className="d-flex gap-4 my-3">
                      <div style={{ flex: 1 }}>
                        <CapitalizedFormikField
                          name="vergiNo"
                          label="Vergi No"
                          variant="outlined"
                          size="small"
                          fullWidth
                          onBlur={handleBlur}
                          error={touched.vergiNo && Boolean(errors.vergiNo)}
                          helperText={touched.vergiNo && errors.vergiNo}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, ""); // rakam dışı karakterleri sil
                          }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <CapitalizedFormikField
                          name="vergiDairesi"
                          label="Vergi Dairesi"
                          variant="outlined"
                          size="small"
                          fullWidth
                          onBlur={handleBlur}
                          error={touched.vergiDairesi && Boolean(errors.vergiDairesi)}
                          helperText={touched.vergiDairesi && errors.vergiDairesi}
                        />
                      </div>
                    </div>
                  )}

                  {/* Şehir ve İlçe */}
                  <div className="d-flex gap-4 my-2">
                    <div style={{ flex: 1 }}>
                      <Autocomplete
                        options={cities}
                        value={values.city || ""}
                        onChange={(e, newValue) => {
                          setFieldValue("city", newValue || "");
                          setFieldValue("district", "");
                          if (newValue) setSearchedCity(newValue);
                        }}
                        onBlur={handleBlur}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Şehir"
                            size="small"
                            fullWidth
                            error={touched.city && Boolean(errors.city)}
                            helperText={touched.city && errors.city}
                          />
                        )}
                        disablePortal
                        autoHighlight
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <Autocomplete
                        options={districts || []}
                        value={values.district || ""}
                        onChange={(e, newValue) => setFieldValue("district", newValue || "")}
                        onBlur={handleBlur}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="İlçe"
                            size="small"
                            fullWidth
                            error={touched.district && Boolean(errors.district)}
                            helperText={touched.district && errors.district}
                          />
                        )}
                        disablePortal
                        autoHighlight
                        disabled={!values.city}
                      />
                    </div>
                  </div>

                  <CapitalizedFormikField
                    name="address"
                    label="Adres"
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    rows={3}
                    className="my-2"
                    onBlur={handleBlur}
                    error={touched.address && Boolean(errors.address)}
                    helperText={touched.address && errors.address}
                  />
                </div>

                {/* Sağ sütun */}
                <div
                  className="flex-fill p-3"
                  style={{
                    border: "1px solid rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                   
                  }}
                >
                  <h5>Ürün / Cihaz Bilgileri</h5>
                  <div className="row my-2 mt-3">
                    <div className="col">
                      <CapitalizedFormikField
                        name="brand"
                        label="Marka"
                        variant="outlined"
                        size="small"
                        fullWidth
                        onBlur={handleBlur}
                        error={touched.brand && Boolean(errors.brand)}
                        helperText={touched.brand && errors.brand}
                      />
                    </div>
                    <div className="col">
                      <CapitalizedFormikField
                        name="device"
                        label="Cihaz"
                        variant="outlined"
                        size="small"
                        fullWidth
                        onBlur={handleBlur}
                        error={touched.device && Boolean(errors.device)}
                        helperText={touched.device && errors.device}
                      />
                    </div>
                  </div>

                  <CapitalizedFormikField
                    name="deviceModel"
                    label="Model"
                    variant="outlined"
                    size="small"
                    fullWidth
                    className="my-2"
                    onBlur={handleBlur}
                    error={touched.deviceModel && Boolean(errors.deviceModel)}
                    helperText={touched.deviceModel && errors.deviceModel}
                  />
                  <CapitalizedFormikField
                    name="issue"
                    label="Arıza Notu"
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    rows={3}
                    className="my-2"
                    onBlur={handleBlur}
                    error={touched.issue && Boolean(errors.issue)}
                    helperText={touched.issue && errors.issue}
                  />
                  <CapitalizedFormikField
                    name="note"
                    label="Ek Not"
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    rows={3}
                    className="my-2"
                    onBlur={handleBlur}
                    error={touched.note && Boolean(errors.note)}
                    helperText={touched.note && errors.note}
                  />

                  <div className="my-2">
                    <label className="form-label">Garanti Durumu</label>
                    <select
                      name="warranty"
                      className="form-select"
                      value={values.warranty}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="var">Var</option>
                      <option value="yok">Yok</option>
                    </select>
                    {touched.warranty && errors.warranty && (
                      <FormHelperText error>{errors.warranty}</FormHelperText>
                    )}
                  </div>

                  <div className="row mt-4">
                    <div className="col-12 col-md-4 mb-3 mb-md-0">
                      <CapitalizedFormikField
                        type="date"
                        name="availableDate"
                        label="Tarih"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        onBlur={handleBlur}
                        error={touched.availableDate && Boolean(errors.availableDate)}
                        helperText={touched.availableDate && errors.availableDate}
                      />
                    </div>
                    <div className="col-12 col-md-8 d-flex flex-column flex-md-row gap-2">
                      <CapitalizedFormikField
                        type="time"
                        name="availableStart"
                        label="Başlangıç Saati"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        onBlur={handleBlur}
                        error={touched.availableStart && Boolean(errors.availableStart)}
                        helperText={touched.availableStart && errors.availableStart}
                      />

                      <CapitalizedFormikField
                        type="time"
                        name="availableEnd"
                        label="Bitiş Saati"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        onBlur={handleBlur}
                        error={touched.availableEnd && Boolean(errors.availableEnd)}
                        helperText={touched.availableEnd && errors.availableEnd}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                İptal
              </button>
              <button type="submit" className="btn btn-primary">
                Kaydet
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default ServiceAddModal;
